/**
 * Sends the browser to the AI app's redirect URI after a consent decision (ADR 0009 section 3).
 * The address is the server's answer (`McpConsentDecisionResult.redirectUrl`), built from a
 * redirect URI that is in `MCP_REDIRECT_URIS`; the page never builds one. `replace`, not
 * `assign`: Back from the AI app must not land on a consent page whose request is spent.
 *
 * Its own module so a test replaces the navigation (jsdom implements none).
 */
export function leaveForClient(redirectUrl: string): void {
  window.location.replace(redirectUrl);
}
